
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import PivotTable from 'components/PivotTable'
import dimensionsList from 'utils/dimensions'
import {getMetricByKey} from 'utils/metrics'
import ChannelGroupTitle from 'components/ChannelGroupTitle'
import ChannelTitle from 'components/ChannelTitle'
import ChartCheckbox from './ChartCheckbox'
import NumberFormat from 'components/NumberFormat'
import AnalyticsChart from 'views/AnalyticsView/AnalyticsChart'
import Container from 'components/ContainerDimentionsContext'
import isEqual from 'lodash/isEqual'

const dimenstionFormatters = {
  'channelGroup': id => <ChannelGroupTitle id={id} />,
  'channel': id => <ChannelTitle id={id} />
}

export default class TrafficReport extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    total: PropTypes.object,
    dimensions: PropTypes.array,
    availableDimensions: PropTypes.object,
    metrics: PropTypes.array,
    filters: PropTypes.object,
    charts: PropTypes.array,
    onFilterChange: PropTypes.func,
    onMetricChange: PropTypes.func,
    onChartCloseClick: PropTypes.func,
    sites: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
  }

  static defaultProps = {
    edit: false
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    return (
      <div className='traffic-report'>
        {this.renderTable()}
        {this.renderCharts()}
      </div>
    )
  }

  renderTable() {
    const {data, filters, total, dimensions, metrics, availableDimensions, onFilterChange} = this.props
    const {permissions} = this.context

    if (!metrics || metrics.length === 0) {
      return <div className='traffic-report_empty'>Please select at least one metric</div>
    }

    const haveDimensions = dimensions.length > 0

    return (
      <div className='traffic-report_table'>
        <PivotTable
          data={haveDimensions ? data : []}
          total={total}
          availableDimensions={availableDimensions}
          filters={filters}
          dimensions={
            haveDimensions ? dimensions.map(dimension => {
              const {format, label} = dimensionsList.find(dimensionItem => dimensionItem.id === dimension)

              return {
                key: `dimensions.${dimension}`,
                id: dimension,
                format,
                label
              }
            }) : []
          }
          metrics={
            metrics.map(metricKey => {
              const {format, label, variantGroup, variantLabel, metricLabel} = getMetricByKey(metricKey)

              return {key: metricKey, format, label, variantGroup, variantLabel, metricLabel}
            }).filter(metric => permissions.read.includes(`@metric/${metric.key}`))
          }
          dimensionCell={this.renderDimensionCell}
          metricCell={this.renderMetricCell}
          onFilterChange={onFilterChange}
        />
      </div>
    )
  }

  renderCharts() {
    const {charts, onMetricChange, onChartCloseClick, sites} = this.props
    if (!charts) return null

    return charts.map((chart, index) => (
      <Container key={index}>
        <AnalyticsChart
          sites={sites}
          metric={chart.metric}
          dimensions={chart.dimensions}
          data={chart.data}
          onCloseClick={onChartCloseClick ? () => onChartCloseClick(chart.metric) : null}
          onLabelClick={onMetricChange ? dimension => onMetricChange(false, chart.metric, dimension) : null}
        />
      </Container>
    ))
  }

  renderDimensionCell = (value, dimension) => {
    const {sites} = this.props

    let formattedValue
    if (dimenstionFormatters[dimension.id]) {
      formattedValue = dimenstionFormatters[dimension.id](value)
    } else if (dimension.format) {
      formattedValue = dimension.format(value, sites)
    } else {
      formattedValue = value
    }

    return (
      <div className='traffic-report_dimension-cell'>
        {formattedValue}
      </div>
    )
  }

  renderMetricCell = (value, metric, metricDimensions) => {
    const {onMetricChange, dimensions} = this.props
    const checked = this.isMetricPlotted(metric.key, metricDimensions)
    const haveDimensions = Object.keys(metricDimensions || {}).length > 0

    const checkBox = onMetricChange ? (
      <ChartCheckbox
        checked={checked}
        onClick={() => {
          onMetricChange(
            !checked,
            metric.key,
            haveDimensions ? dimensions.map(dimension => {
              return {[dimension]: metricDimensions[dimension]}
            }) : []
          )
        }}
      />
    ) : null

    return (
      <div className='traffic-report_metric-cell'>
        {checkBox}
        {value === undefined ? <span>—</span> : <NumberFormat value={value} format={metric.format} />}
      </div>
    )
  }

  isMetricPlotted(metric, metricDimension) {
    const {charts} = this.props
    const chart = charts.find(chart => chart.metric === metric)
    if (!chart) return false

    const haveDimensions = Object.keys(metricDimension || {}).length > 0

    return chart.dimensions.some(dimension => {
      return isEqual(
        dimension.reduce((acc, dimensionPart) => Object.assign(acc, dimensionPart), {}),
        (haveDimensions ? metricDimension : {}) || {}
      )
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/TrafficReport/index.js